import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	position: relative;
	margin: 0 auto;
	max-width: 1420px;
	padding: 100px 20px;

	.main-content-wrapper {
		margin-top: 30px;
		display: flex;
		gap: 50px;
		max-width: 1220px;
		margin: 0 auto;

		@media (max-width: 655px) {
			flex-direction: column;
		}

		.filter-container {
			min-width: 220px;
			display: flex;
			flex-direction: column;
			gap: 15px;
			position: sticky;
			top: 30px;
			height: fit-content;

			@media (max-width: 655px) {
				position: static;
			}

			.categories {
				padding-left: 10px;
				display: flex;
				flex-direction: column;

				.cat-title {
					font-weight: 500;
					font-size: ${CSSVars.fontSizeSM};
					color: #000000;
					margin: 5px 0;
				}

				.divider {
					border-top: 1px solid rgba(0, 0, 0, 0.15);
					margin: 5px 0;
				}

				.cat {
					cursor: pointer;
					display: flex;
					align-items: center;
					color: ${CSSVars.black};
					gap: 10px;
					border: none;
					background: transparent;
					font-weight: 300;
					font-size: ${CSSVars.fontSizeSM};
					line-height: 17px;
					transition: 0.2s;
					padding: 10px;
					border-radius: 5px;

					.icon {
						font-size: 18px;
					}

					&:hover {
						color: ${CSSVars.blue};
					}

					&.active{
						color: ${CSSVars.blue};
						background-color: ${CSSVars.blue50};
					}
				}
			}
		}

		.widget-catalog-home {
			display: flex;
			flex-direction: column;
			gap: 100px;

			h3 {
				font-size: 22px;
				font-weight: 600;
				display: flex;
				align-items: center;
				gap: 5px;
				margin: 0 0 30px;

				svg {
					color: #747b95;
				}
			}
		}

		.apps-container {
			gap: 20px;
			display: flex;
			align-items: flex-start;
			flex-wrap: wrap;

			&:has(.no-items) {
				align-items: center;
				width: 100%;
			}

			.no-items {
				min-width: 100%;
				display: flex;
				flex-direction: column;
				gap: 30px;
				align-items: center;
				margin: 0 auto;

				p {
					font-size: 16px;
					padding-left: 20px;
				}

				img {
					max-width: 200px;
				}
			}

			.app {
				background-color: ${CSSVars.white};
				border: 1px solid ${CSSVars.gray50};
				border-radius: 5px;
				cursor: pointer;
				position: relative;
				display: flex;
				flex-direction: column;
				flex: 1;
				transition: 0.2s;
				min-width: 280px;
				max-width: 330px;

				@media (max-width: 655px) {
					max-width: 100%;
				}

				&:hover {
					border: 1px solid ${CSSVars.gray100};
				}

				img {
					width: 100%;
					height: 170px;
					object-fit: cover;
					border-radius: 5px 5px 0 0;
				}

				.details {
					display: flex;
					flex-direction: column;
					gap: 5px;
					color: #1e2a3b;
					padding: 20px;
					min-height: 120px;

					h3 {
						font-weight: 500;
						font-size: 18px;
						line-height: 20px;
						margin: 0;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
					}

					p {
						margin: 0;
						font-weight: 300;
						font-size: ${CSSVars.fontSizeSM};
						line-height: 20px;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						line-clamp: 3;
						-webkit-box-orient: vertical;
					}
				}
			}
		}
	}
`;
